module.exports = __webpack_public_path__ + "static/images/containers/ClanLanding/components/AnnouncementsCard/images/default_news_bg_with_quests.98fcf39a.jpg";


//////////////////
// WEBPACK FOOTER
// ./containers/ClanLanding/components/AnnouncementsCard/images/default_news_bg_with_quests.jpg
// module id = 2893
// module chunks = 11